var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalkBubbles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 310.43,
    x2: 310.43,
    y1: 222.051,
    y2: 432.656
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dc4955"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c4237c"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a1958",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a1958"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 415.675,
    x2: 214.777,
    xlinkHref: "#lg1",
    y1: 374.845,
    y2: 173.947
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 310.423,
    x2: 310.423,
    xlinkHref: "#lg1",
    y1: 406.382,
    y2: 489.294
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 90.603,
    x2: 303.233,
    y1: 14.985,
    y2: 353.396
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#76ccf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833,
    stopColor: "#518ef8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4981f8"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 178.53,
    x2: 178.53,
    y1: 202.667,
    y2: 284.691
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4071f7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30569f"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfe7fd"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientTransform: "matrix(-1 0 0 1 339.938 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 67.94,
    x2: 107.468,
    xlinkHref: "#lg2",
    y1: 112.61,
    y2: 152.138
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientTransform: "matrix(-1 0 0 1 339.938 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 145.521,
    x2: 185.049,
    xlinkHref: "#lg2",
    y1: 112.61,
    y2: 152.138
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientTransform: "matrix(-1 0 0 1 339.938 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 223.102,
    x2: 262.63,
    xlinkHref: "#lg2",
    y1: 112.61,
    y2: 152.138
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientTransform: "matrix(-1 0 0 1 339.938 0)",
    gradientUnits: "userSpaceOnUse",
    x1: -63.464,
    x2: -23.936,
    xlinkHref: "#lg2",
    y1: 320.991,
    y2: 360.519
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientTransform: "matrix(-1 0 0 1 339.938 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 14.118,
    x2: 53.646,
    xlinkHref: "#lg2",
    y1: 320.991,
    y2: 360.519
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientTransform: "matrix(-1 0 0 1 339.938 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 91.699,
    x2: 131.227,
    xlinkHref: "#lg2",
    y1: 320.991,
    y2: 360.519
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 236.377,
    x2: 236.377,
    y1: 197.333,
    y2: 301.641
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9d66d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#453d81"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m269.701 171.061c-72.209 0-130.451 49.439-152.468 112.319-4.848 13.847-6.373 29.006-6.373 44.523 0 87.725 71.116 158.841 158.841 158.841h81.458c9.238 0 18.276-.833 27.081-2.347l47.967 23.827c11.925 5.924 25.651-3.794 24.026-17.01l-4.398-35.77c38.935-28.949 64.165-75.295 64.165-127.541 0-86.251-68.745-156.445-154.431-158.781z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m445.84 455.44 4.39 35.77c1.63 13.22-12.1 22.94-24.02 17.01l-47.97-23.82c-8.81 1.51-17.84 2.34-27.08 2.34h-30.6l-203.36-203.37-.02.05c18.82-62.92 80.24-112.36 152.52-112.36l85.869-1.94c42.109 1.148 80.128 18.686 107.911 46.46 28.74 28.75 46.52 68.46 46.52 112.32 0 52.25-25.23 98.6-64.16 127.54z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m499.151 385.663h-377.457c23.107 59.165 80.66 101.081 148.007 101.081h81.458c9.238 0 18.276-.833 27.081-2.347l47.967 23.827c11.925 5.924 25.651-3.794 24.026-17.01l-4.398-35.77c23.746-17.656 42.38-41.791 53.316-69.781z",
    fill: "url(#SVGID_3_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m142.491 0h73.072c78.695 0 142.491 63.795 142.491 142.491 0 9.102-.853 18.005-2.485 26.632-12.472 65.967-70.413 114.858-140.006 114.858h-73.073c-8.287 0-16.394.253-24.294-1.105l-43.03 21.374c-10.698 5.314-23.011-3.404-21.553-15.259l3.945-32.088c-34.925-25.968-57.558-67.544-57.558-114.412 0-78.696 63.795-142.491 142.491-142.491z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.13 190c9.529 26.941 26.92 50.167 49.43 66.904l-3.945 32.088c-1.458 11.855 10.856 20.573 21.553 15.259l43.03-21.375c7.899 1.358 16.007 1.105 24.293 1.105h73.073c62.035 0 113.801-38.647 133.367-93.981z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256.608,
    cy: 128,
    fill: "url(#SVGID_6_)",
    r: 27.845
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.027,
    cy: 128,
    fill: "url(#SVGID_7_)",
    r: 27.845
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101.445,
    cy: 128,
    fill: "url(#SVGID_8_)",
    r: 27.845
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 388.012,
    cy: 336.381,
    fill: "url(#SVGID_9_)",
    r: 27.845
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.43,
    cy: 336.381,
    fill: "url(#SVGID_10_)",
    r: 27.845
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.849,
    cy: 336.381,
    fill: "url(#SVGID_11_)",
    r: 27.845
  })), /*#__PURE__*/React.createElement("path", {
    d: "m355.558 169.125c-1.462-.04-2.928-.063-4.399-.063h-81.457c-72.266 0-133.251 48.263-152.505 114.312l1.001-.497c7.899 1.358 16.007 2.105 24.293 2.105h73.073c69.591-.001 127.52-49.893 139.994-115.857z",
    fill: "url(#SVGID_12_)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalkBubbles);
export default __webpack_public_path__ + "static/media/talk-bubbles.4b24e55ef59d098084a0147886aed189.svg";
export { ForwardRef as ReactComponent };